export const setVagaCandidato = (vagaCandidato) => ({
	type: 'SET_VAGA_CANDIDATO',
	vagaCandidato
})

export const unsetVagaCandidato = () => ({
	type: 'UNSET_VAGA_CANDIDATO'
})
